"use client";

import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid"; // GLOBAL CUSTOM COMPONENTS
import { Product } from "src/lib/fetcher/client";
import SalifyFallback from "../../salify-fallback/default";
import { H3 } from "../../salify-next-layout/default/components/Typography";
import { Theme, useMediaQuery } from "@mui/material";
import ProductItemHorizontal from "../../product-item/horizontal";
import ProductItemVertical from "../../product-item/vertical";

// ==============================================================
const RelatedProducts = ({ products }: { products: Product[] }) => {
  const isMobile = useMediaQuery<Theme>((theme) => theme.breakpoints.down("md"));
  const ProductCard = isMobile ? ProductItemVertical : ProductItemHorizontal;
  return products.length ? (
    <Box p={-1}>
      <H3 mb={1}>
        <SalifyFallback.Label path="Related Products" default="Có thể bạn thích" />
      </H3>

      <Grid container spacing={{ xs: "14px", md: "12px" }} direction={{ xs: "row", md: "column" }}>
        {products.map((item) => (
          <Grid item xs={6} key={item.id}>
            <ProductCard {...item} />
          </Grid>
        ))}
      </Grid>
    </Box>
  ) : null;
};

export default RelatedProducts;
